module.exports = __webpack_public_path__ + "img/Kimberly Butler.fd35469f.jpg";